@if (visible()) {
  <div class="starting-price-banner__viewport">
    <aside
      class="starting-price-banner"
      [attr.aria-label]="'HOME.STARTING_PRICE_BANNER.TITLE' | transloco"
      dataAttribute
      componentName="starting-price-banner"
    >
      <div class="starting-price-banner__content">
        <span class="starting-price-banner__title">
          {{ 'HOME.STARTING_PRICE_BANNER.TITLE' | transloco }}
        </span>

        <div class="starting-price-banner__actions">
          <img
            class="starting-price-banner__arrow"
            src="assets/images/starting-price-banner/arrow.svg"
            alt=""
            aria-hidden="true"
          />

          <div class="starting-price-banner__contact-wrapper">
            <button
              pButton
              type="button"
              class="starting-price-banner__contact"
              (click)="openManagerContacts()"
              dataAttribute
              componentName="starting-price-banner-contact"
            >
              <span
                class="p-button-label starting-price-banner__contact-label starting-price-banner__contact-label--desktop"
              >
                {{ 'HOME.STARTING_PRICE_BANNER.CONTACT_MANAGER' | transloco }}
              </span>
              <span
                class="p-button-label starting-price-banner__contact-label starting-price-banner__contact-label--mobile"
              >
                {{ 'HOME.STARTING_PRICE_BANNER.CONTACT' | transloco }}
              </span>
            </button>

            <img
              class="starting-price-banner__sparks"
              src="assets/images/starting-price-banner/sparks.svg"
              alt=""
              aria-hidden="true"
            />
          </div>

          <button
            pButton
            type="button"
            class="p-button-text starting-price-banner__close"
            [attr.aria-label]="'HOME.STARTING_PRICE_BANNER.CLOSE' | transloco"
            (click)="dismiss()"
            dataAttribute
            componentName="starting-price-banner-close"
          >
            <i
              class="pi pi-times starting-price-banner__close-icon"
              aria-hidden="true"
            ></i>
          </button>
        </div>
      </div>
    </aside>
  </div>
}
